<template>
  <v-app>
    <appbar-view></appbar-view>

    <v-main class="main-content">
      <v-container>
        <!-- Campo de búsqueda -->
        <v-row>
          <v-col cols="12">
            <v-text-field 
              v-model="searchQuery" 
              variant="solo" 
              label="Buscar productos o SKU" 
              append-icon="mdi-search-web" 
              solo
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Botón del carrito flotante -->
        <v-row>
          <v-col cols="12">
            <v-btn @click="openCart" color="white" class="mb-4 fixed-cart-btn">
              <v-img src="https://cdn-icons-png.flaticon.com/512/630/630746.png" width="50px" height="50px" class="mr-2"></v-img>
              ({{ cart.length }})
            </v-btn>
          </v-col>
        </v-row>

        <!-- Productos -->
        <v-row dense>
  <v-col 
    v-for="product in filteredProducts" 
    :key="product.id" 
    xs="3" 
    sm="3" 
    md="3" 
    lg="2" 
    class="d-flex justify-center"
  >
    <v-card class="pa-2" max-width="120">
      <v-row class="d-flex flex-column align-center justify-center">
        <!-- Imagen del producto -->
        <v-col cols="12" class="d-flex justify-center">
          <v-img :src="product.foto || 'default-image-url'" height="80px" class="rounded"></v-img>
        </v-col>

        <v-col cols="12" class="text-center mt-1">
          <div class="font-weight-bold text-truncate">${{ product.price }}</div>
          <div class="text-truncate">SKU: {{ product.sku }}</div>
          <div class="text-truncate mt-1">{{ product.nombre }}</div>
        </v-col>

        <v-col cols="12" class="d-flex justify-center mt-2">
          <v-btn class="text-none text-subtitle-1" color="primary" small @click="addToCart(product)">
            <v-icon left>mdi-cart</v-icon> Añadir
          </v-btn>
        </v-col>
        
      </v-row>
    </v-card>
  </v-col>
</v-row>


        <!-- Diálogo del carrito -->
        <v-dialog v-model="cartDialog" max-width="600" scrollable>
          <v-btn class="text-none font-weight-h4" color="#FB8C00" size="small" text="CARRITO DE COMPRA" variant="flat"></v-btn>

          <v-card>
            <v-card-title class="headline">Carrito de Compras</v-card-title>
            <v-card-text>
              <v-list-item v-if="cart.length === 0">
                <v-list-item>
                  <v-list-item-title>No hay productos en el carrito</v-list-item-title>
                </v-list-item>
              </v-list-item>

              <!-- Mostrar productos si hay en el carrito -->
              <div v-for="(item, index) in cart" :key="index" class="cart-item">
                <v-row no-gutters align="center" class="mb-3">
                  <!-- Imagen del producto -->
                  <v-col cols="12" sm="2" class="d-flex align-center justify-center mb-2">
                    <v-img :src="item.foto" width="50px" height="50px"></v-img>
                  </v-col>

                  <v-col cols="12" sm="6" class="d-flex flex-column align-center align-sm-start">
                    <span>{{ getShortProductName(item.nombre) }}</span>
                    <span class="font-weight-bold">SKU:{{ item.sku }}</span>
                    <span class="font-weight-bold">${{ item.price }}</span>
                    
                  </v-col>

                  <!-- Cantidad y botones para aumentar/disminuir -->
                  <v-col cols="12" sm="4" class="d-flex justify-center justify-sm-end align-center mt-2">
                    <v-btn @click="item.quantity--" :disabled="item.quantity <= 1" icon small class="p-0" elevation="0">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>

                    <span class="mx-2">PZA {{ item.quantity }}</span>

                    <v-btn @click="item.quantity++" icon small class="p-0" elevation="0">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>

                    <v-btn @click="removeFromCart(index)" icon small class="p-0 ml-2" elevation="0">
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </div>

              <!-- Total del carrito -->
              <div class="d-flex justify-end align-center mt-3">
                <span class="font-weight-bold">Total: ${{ calculateTotal() }}</span>
              </div>

              <!-- Sugerencias de productos -->
        <!-- Sugerencias de productos -->
        <div v-if="suggestedItems.length > 0" class="mt-4">
                <h3 class="subtitle-2 mb-2">Productos que te pueden interesar</h3>
                <v-row>
                  <v-col v-for="product in suggestedItems" :key="product.id" cols="12" sm="6" md="4" class="d-flex flex-column align-center">
                    <v-img :src="product.foto" width="100" height="100" alt="Imagen del producto"></v-img>
                    <span class="mt-2">{{ product.nombre }}</span>
                    <span class="font-weight-bold">${{ product.price || 'N/A' }}</span>
                    <v-btn class="text-none text-subtitle-1" color="white" size="small" variant="tonal" @click="addToCart(product)">
                      <v-img src="https://img.icons8.com/?size=512&id=63650&format=png" width="20px" height="20px" class="mr-2"></v-img>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>


              
            </v-card-text>

            <v-card-actions>
              <!-- Botones para cerrar el diálogo o proceder con la compra -->
              <v-btn @click="cartDialog = false" color="secondary" small>Cerrar</v-btn>
              <v-btn @click="checkout" color="primary" small>
                <v-icon>mdi-check-decagram-outline</v-icon> Pagar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Navegación en la parte inferior -->
        <bottom-navigation />

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import AppbarView from './appbar/appbarView.vue';
import BottomNavigation from './submenu/BottomNavigation.vue';

export default {
  name: 'ExpressMV',
  components: { BottomNavigation, AppbarView },
  data() {
    return {
      searchQuery: '',
      products: [],
      cart: [],
      cartDialog: false,
      sugerencias:[],
      suggestedItems: [], // Cambiamos el nombre de sugerencias


    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter(product => product.nombre.toLowerCase().includes(this.searchQuery.toLowerCase()));
    },
  },
  methods: {
    async fetchProducts() {
  try {
    const token = localStorage.getItem('token'); // Recupera el token del localStorage

    if (!token) {
      console.error('No token found, please login again');
      return;
    }

    // Envía la solicitud con el token en los encabezados
    const response = await axios.get('https://mvexpress.mx/api/products', {
      headers: {
        Authorization: `Bearer ${token}`, // Incluye el token en el encabezado de la solicitud
      },
    });


  // console.log('token', token);

    // Mapeamos los productos para añadirles la propiedad `price`
    this.products = response.data.map(product => {
      return {
        ...product,
        price: product.prices.length > 0 ? product.prices[0].price : 0, // Asignar el primer precio o 0 si no hay precios
      };
    });
  } catch (error) {
    console.error('Error fetching products:', error.message);
  }
},


    openCart() { this.suggestedProducts();
      this.cartDialog = true;
      this.suggestedProducts();
 
    },
    addToCart(product) {
  // Busca un producto con el mismo `sku` y `id` en el carrito
  const existingProduct = this.cart.find(item => item.sku === product.sku && item.id === product.id);

  if (existingProduct) {
    existingProduct.quantity++;  // Si ya existe, aumenta la cantidad
  } else {
    this.cart.push({ ...product, quantity: 1 });  // Si no existe, agrega el producto con cantidad 1
  }
},
    removeFromCart(index) {
      this.cart.splice(index, 1);
    },
    calculateTotal() {
      return this.cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
    },
    checkout() {

      const total = this.cart.reduce((acc, item) => acc + item.price *  item.quantity,0);
      this.cart = [];
      this.cartDialog = false;

      this.$router.push({
        path:'/metodo-pago',
        query:{total}

      }
      )
    },
    getShortProductName(name) {
      return name.length > 20 ? `${name.slice(0, 20)}...` : name;
    },
    
suggestedProducts() {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('No token found. Please login first.');
    return;
  }

  axios.get('https://mvexpress.mx/api/productos/suggested-products', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then(res => {
    if (Array.isArray(res.data) && res.data.length > 0) {
      this.suggestedItems = res.data;
    } else {
      console.error('No se encontraron productos sugeridos.');
    }
    //console.log(this.suggestedItems);
  })
  .catch(err => {
    console.error('Error fetching suggested products:', err);
  });
},




  },
  mounted() {
   
    //console.log('MV EXPRESS:', localStorage.getItem('user'));
    const token = localStorage.getItem('token');

    if(!token){

      window.location.replace('/');  // Redirige y borra el historial

    }

    ///


    this.fetchProducts(); // Llama a la API para obtener los productos cuando el componente se monta
  }
};
</script>

<style scoped>
.main-content {
  padding-bottom: calc(80px + env(safe-area-inset-bottom));
  background-color: #0d00bd;

}

.fixed-cart-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10;
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.cart-item {
  padding: 10px 0;
}

.v-dialog .v-card {
  background-color: #ffffff;
}

.v-row {
  margin-bottom: 10px;
}
</style>

<style scoped>
.cart-table {
  width: 100%;
  border-collapse: collapse;
}

.cart-table th,
.cart-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.cart-table th {
  background-color: #f5f5f5;
  text-align: left;
}

.actions-column {
  width: 150px;
  /* Ajusta el tamaño de la columna de acciones */
  text-align: center;
}

.fixed-cart-btn {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 10;
  /* Asegura que el carrito esté por debajo del diálogo */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.v-dialog__content {
  z-index: 9999;
  /* Asegura que el diálogo esté por encima del carrito */
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 10px;
}

.main-content {
  padding-bottom: 80px;
  /* Asegura que el contenido no quede tapado por el pie de página */
}

v-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
  padding: 10px 0;
  text-align: center;
}
</style>
